'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondAfter.js
// module id = 730
// module chunks = 0